<template>
    <div class="vip-panel-wrapper" @click.stop="closePanel">
        <div class="panel-content" @click.stop="showPanel">
            <div class="title" :style="{backgroundImage: `url(${vipTitle})`}"></div>
            <div class="discount">限时<span>¥{{ initPrice(vipPanelInfo.extra_sku.activity_price) }}</span>
                开通贴吧会员立享优惠，本单可省<span>¥{{ initPrice(vipPanelInfo.extra_sku.discount_amount) }}</span>
            </div>
            <div
                v-for="(item, index) in vipPanelInfo.discount_list"
                :key="index"
                :style="{backgroundImage: `url(${vipCoupon})`}"
                class="coupon"
            >
                <div class="left">
                    <div class="title">{{ item.discount_name }}</div>
                    <div class="tips">{{ item.discount_desc }}</div>
                </div>
                <div class="right">
                    ¥<div>{{ initPrice(item.discount_amount) }}</div><div class="right-txt">立减</div>
                </div>
            </div>
            <img
                :src="closeIcon" class="closeIcon"
                @click.stop="closePanel"
            >
            <div class="discount">开通贴吧会员享更多折扣优惠，每月可省<span>
                ¥{{ initPrice(monthDiscountSum) }}</span>
            </div>
            <div class="other-coupon">
                <div
                    v-for="(item, index) in tiebaVipVoucherInfo"
                    :key="index"
                    :style="{backgroundImage: `url(${vipCard})`}"
                    class="card"
                >
                    <div class="price">¥<span>{{ initPrice(item.voucher_money) }}</span></div>
                    <div class="limit">满¥<span>{{ initPrice(item.threshold_min_money) }}</span>可用</div>
                </div>
            </div>
            <div class="button" @click="buyGame">
                <div class="btn-text">立即购买</div>
                <div class="btn-tips">
                    <!-- eslint-disable-next-line max-len -->
                    （总价¥{{ initPrice(vipPanelInfo.total_price_witch_extra) }}，贴吧会员¥{{ initPrice(vipPanelInfo.extra_sku.activity_price) }} +游戏价¥{{ initPrice(vipPanelInfo.game_real_price) }}）
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vipTitle from 'public/assets/imgs/tb-vip-title.png';
import vipCoupon from 'public/assets/imgs/tb-vip-coupon.png';
import vipCard from 'public/assets/imgs/tb-vip-card.png';
import closeIcon from 'public/assets/imgs/tieba-vip-panel-close-icon.png';
import {getUrlParams} from '@/utils/url';
import {openPage} from '@/utils/utility';
export default {
    props: {
        vipPanelInfo: {
            type: Object,
            default: () => {},
        },
        tiebaVipVoucherInfo: {
            type: Array,
            default: () => [],
        },
        appId: {
            type: String,
            default: '',
        },
        appName: {
            type: String,
            default: '',
        },
        appType: {
            type: Number,
            default: 0,
        },
        monthDiscountSum: {
            type: Number,
            default: 0,
        },
        // 已购买过文案
        buyAlreadyText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            vipTitle,
            vipCard,
            closeIcon,
            vipCoupon,
        };
    },
    created() {
        document.body.style.overflowY = 'hidden';
        this.$root.sendLog('display', 'tiebaVipPanel_display');
    },
    destroyed() {
        document.body.style.overflowY = '';
    },
    methods: {
        closePanel() {
            this.$root.isShowVipPanel = false;
            this.$root.sendLog('click', 'close_tiebaVipPanel_click');
        },
        showPanel() {
            this.$root.isShowVipPanel = true;
        },
        buyGame() {
            this.$root.sendLog('click', 'tiebaVipPanel_buy_click');
            setTimeout(() => {
                const {srcid, channelid, idfrom} = getUrlParams();
                if (this.$root.currentSkuInfo.has_unpaid_order) {
                    openPage('orderList', getUrlParams());
                }
                else {
                    openPage('orderConfirm', {
                        sku_id: this.$root.currentSkuId,
                        app_type: this.appType,
                        app_id: this.appId,
                        app_name: this.appName,
                        srcid: srcid,
                        channelid: channelid || idfrom,
                        type: this.$root.productType,
                        buy_flag: this.buyAlreadyText ? 1 : '',
                        buyTiebaVip: 1,
                    });
                }
            }, 200);
        },
        initPrice(price) {
            const priceStr = price.toString();
            if (priceStr.slice(-2) === '00' && price !== 0) {
                return priceStr.slice(0, -2);
            }
            else if (price === 0) {
                return 0;
            }
            else if (priceStr[priceStr.length - 1] === '0') {
                return Number(price * 0.01).toFixed(1);
            }
            return Number(price * 0.01).toFixed(2);
        },
    },
};
</script>

<style lang="scss">
    .vip-panel-wrapper {
        position: fixed;
        width: 100%;
        height: 100vh;
        left: 0;
        top: 0;
        background: rgba(0,0,0,0.30);
        z-index: 9999;
        font-family: PingFangSC-Medium;
        .panel-content {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #fff;
            border-radius: 36px 36px 0px 0px;
            padding: 71px 51px 51px 51px;
            box-sizing: border-box;
            .title {
                width: 688px;
                height: 54px;
                background-size: 100% 100%;
                margin: 0 auto;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .closeIcon {
                width: 54px;
                height: 54px;
                position: absolute;
                top: 72px;
                right: 40px;
            }
            .discount {
                font-size: 50px;
                font-weight: 500;
                color: #1F1F1F;
                line-height: 50px;
                margin-top: 72px;
                span {
                    color: #FD4E03;
                }
            }
            .coupon {
                width: 100%;
                height: 277px;
                background-size: cover;
                display: flex;
                align-items: center;
                padding: 0 76px 0 90px;
                box-sizing: border-box;
                margin-top: 45px;
                .left {
                    .title {
                        font-family: PingFangSC-Semibold;
                        font-size: 50px;
                        color: #382922;
                        line-height: 50px;
                        font-weight: 600;
                    }
                    .tips {
                        font-family: PingFangSC-Regular;
                        font-size: 36px;
                        color: #A7876D;
                        line-height: 36px;
                        margin-top: 30px;
                    }
                }
                .right {
                    margin-left: auto;
                    color: #8E541F;
                    display: flex;
                    align-items: baseline;
                    div {
                        font-size: 88px;
                        font-weight: 500;
                    }
                    .right-txt {
                        font-size: 42px;
                        font-weight: 500;
                    }
                }
            }
            .other-coupon {
                display: flex;
                margin-top: 45px;
                .card {
                    width: 314px;
                    height: 153px;
                    background-size: 100% 100%;
                    margin-right: 15px;
                    color: #8B511E;
                    div {
                        text-align: center;
                    }
                    .price {
                        font-family: PingFangSC-Semibold;
                        font-size: 30px;
                        font-weight: 600;
                        line-height: 66px;
                        margin-top: 21px;
                        font-weight: 600;
                        span {
                            font-size: 66px;
                        }
                    }
                    .limit {
                        opacity: 0.8;
                        font-family: PingFangSC-Regular;
                        font-size: 36px;
                        text-align: center;
                        font-weight: 400;
                        line-height: 33px;
                    }
                }
            }
            .button {
                width: 100%;
                height: 150px;
                background-image: linear-gradient(90deg, #494848 0%, #1C1C1C 100%);
                border-radius: 75px;
                color: #FFE7B6;
                margin-top: 72px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .btn-text {
                    font-size: 51px;
                    line-height: 51px;
                    font-weight: 500;
                }
                .btn-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 30px;
                    line-height: 30px;
                    margin-top: 15px;
                }
            }
        }
    }
</style>